export default __webpack_public_path__ + "static/media/IN500.6c837b09.svg";